<template>
<div>
  <el-dialog
      :title="editMode + ' Custom Disposition'"
      :visible.sync="should_show_disposition_dialog"
  >
    <FormManager
        @save="save"
        :events="events"
        prettyEndPoint='/api/utilities/pretty_disposition_definition_map'
        :initialFormValues="editedDisposition"
    />
  </el-dialog>

  <p>
  A note on disposition effort estimates: These are estimates for the <em>manual</em>
  effort expended <em>per content item</em>. There may be a totally separate pocket of effort
  required technically or at a site-wide level (such as modifying the navigation).
  </p>

  <span v-if="permissions.includes('SELECT_EXTENT')" style="margin-right:15px;margin-bottom:20px">
         View<el-switch v-model="edit_mode" style='margin-left:5px;margin-right:5px'></el-switch>Edit
  </span>

  <h2 v-if="dispositions.used && dispositions.used.hasOwnProperty('all')">
      Already-used dispositions
  </h2>
    <div v-if="dispositions.used && dispositions.used.hasOwnProperty('all')" style="margin-bottom:20px;">
  <el-table
    :data="dispositions.used.all"
    >

    <el-table-column
        label="Name"
        prop="name"
        sortable
    ></el-table-column>
    <el-table-column
        label="Definition"
        prop="definition"
    ></el-table-column>
    <el-table-column
        label="Estimated Minutes Per"
        prop="effort_per_item_in_minutes"
        sortable
    ></el-table-column>
    <el-table-column
        label="Rule Count"
        prop="rule_count"
        v-if="edit_mode"
        sortable
    ></el-table-column>
    <el-table-column
        label="Type"
        prop="type"
        v-if="edit_mode"
        sortable
    >
      <template slot-scope="scope" v-if="edit_mode">
        {{scope.row.type}}
        <div v-if="scope.row.hasOwnProperty('details') && scope.row.details && scope.row.details.hasOwnProperty('dispositions_db_slug') && scope.row.details.dispositions_db_slug">
          <a :href="'/db/dispositions/' + scope.row.details.dispositions_db_slug">DB page</a>
        </div>

      </template>
    </el-table-column>
      <el-table-column
              prop="id"
              label="Actions"
              v-if="edit_mode"
      >
          <template slot-scope="scope">
              <span v-if="scope.row.type==='Custom'">
                  <div>
                      <el-button @click="edit(scope.row.details)">Edit</el-button>
                  </div>
                  <div style="font-size:smaller;">
                      <em>To remove, first remove from all rules that use it.</em>
                  </div>
              </span>

          </template>
      </el-table-column>
  </el-table>
    </div>
    <div v-else>None yet.</div>

    <div v-if="edit_mode">
  <h2>Created custom for extent, but currently unused</h2>
  <el-table
    :data="unused_extent_dispositions"
    row-key="id"
  >
    <el-table-column
        label="Name"
        prop="title"
    ></el-table-column>
    <el-table-column
        label="Definition"
        prop="definition"
    ></el-table-column>
    <el-table-column
        label="Estimated Minutes Per"
        prop="effort_per_item_in_minutes"
    ></el-table-column>
    <el-table-column
        prop="id"
        label="Actions"
    >
      <template slot-scope="scope">
        <el-button @click="edit(scope.row)">Edit</el-button>
        <el-button @click="remove(scope.row)">Remove</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-button @click="show_disposition_dialog" style="margin-top:20px;margin-bottom:20px;">Add Custom</el-button>
        </div>
</div>
</template>

<script>
export default {
  name: "Dispositions",
  props: ['extent_id'],
  data() {
    return {
        permissions: null,
        edit_mode: false,
      should_show_disposition_dialog: false,
      dispositions: [],
      events: {
        save: {
          label: "Save",
          event: "save"
        },
      },
      editedDisposition: {
        title: null,
        definition: null,
        effort_per_item_in_minutes: null,
        id: null,
      },
      editMode: 'None'
    }
  },
  mounted() {
      this.permissions = chimera.permissions
      this.get_dispositions()
  },
  computed: {
    used_extent_disposition_ids: function () {
      return this.dispositions.used.by_extent_rules.map(disposition => disposition.id)
    },
    unused_extent_dispositions: function () {
        if (this.dispositions.available) {
            return this.dispositions.available.defined_for_extent.filter((disposition) => {
                return ! this.used_extent_disposition_ids.includes(disposition.id)
            })
        } else {
            return null
        }
    },
  },
  methods: {
    get_dispositions() {
      axios.get('/api/dispositions/' + this.extent_id)
          .then(response => {
            this.dispositions = response.data
          })
          .catch(error => {
            console.log('oops getting existing dispositions')
          })
    },
    show_disposition_dialog() {
      this.editMode = 'Add'
      this.editedDisposition = {
        title: null,
        definition: null,
        effort_per_item_in_minutes: null,
        id: null,
      }
      this.should_show_disposition_dialog = true
    },
    edit(disposition) {
      this.editMode = 'Edit'
      this.editedDisposition = disposition
      this.should_show_disposition_dialog = true
    },
    remove(disposition) {
      axios.delete('/api/dispositions/' + this.extent_id + '/' + disposition.id)
          .then(response => {
            console.log('deleted disposition')
            this.get_dispositions()
            this.should_show_disposition_dialog = false
          })
          .catch(error => {
            console.log('could not delete')
          })
    },
    save(values) {
      console.log(values)
      axios.post('/dispositions/' + this.extent_id, {
        values: values,
      }).then(response => {
        console.log(response)
        if (this.editMode==='Edit') {
          let index = this.dispositions.available.defined_for_extent.findIndex((obj => obj.id === this.editedDisposition.id));
          console.log('index')
          console.log(index)
          this.dispositions.available.defined_for_extent[index] = {
            ...values
          }
          console.log(this.dispositions.available.defined_for_extent[index])
        } else {
          this.dispositions.available.defined_for_extent.push(response.data)
        }
        console.log(this.dispositions.available.defined_for_extent)
        this.should_show_disposition_dialog = false
        this.editMode = 'None'
      }).catch(error => {
        console.log('oops problem saving')
        console.log(error.response)
      })
    },
  },
}
</script>

<style scoped>

</style>